import React, { useEffect, useRef, useState } from "react";

const TechStackSlider = () => {
  const sliderRef = useRef(null);
  const containerRef = useRef(null);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [direction, setDirection] = useState(1);
  const [isAutoPlay, setIsAutoPlay] = useState(true);

  const techStack = [
    { name: "OpenAI", logoUrl: "/new-final-data/web/slider/T1.png" },
    { name: "React", logoUrl: "/new-final-data/web/slider/T2.png" },
    { name: "Woo commerce", logoUrl: "/new-final-data/web/slider/T3.png" },
    { name: "Wordpress", logoUrl: "/new-final-data/web/slider/T4.png" },
    { name: "Python", logoUrl: "/new-final-data/web/slider/T5.png" },
    { name: "Laravel", logoUrl: "/new-final-data/web/slider/T6.png" },
    { name: "My-SQL", logoUrl: "/new-final-data/web/slider/T7.png" },
    { name: "PHP", logoUrl: "/new-final-data/web/slider/T8.png" },
  ];

  // Calculate visible cards and total slides
  const itemWidth = 280;
  const [visibleCards, setVisibleCards] = useState(4);
  const totalSlides = Math.max(1, techStack.length - visibleCards + 1);

  // Update visible cards on resize
  useEffect(() => {
    const updateVisibleCards = () => {
      if (containerRef.current) {
        const newVisibleCards = Math.max(
          1,
          Math.floor(containerRef.current.offsetWidth / itemWidth)
        );
        setVisibleCards(newVisibleCards);
      }
    };

    updateVisibleCards();
    window.addEventListener("resize", updateVisibleCards);
    return () => window.removeEventListener("resize", updateVisibleCards);
  }, []);

  // Manual navigation function for dots
  const moveToSlide = (index) => {
    const slider = sliderRef.current;
    if (!slider) return;

    // Stop auto-play temporarily when user interacts
    setIsAutoPlay(false);
    setCurrentIndex(index);

    slider.style.transform = `translateX(-${index * itemWidth}px)`;
    slider.style.transition = "transform 0.6s ease";

    // Resume auto-play after 3 seconds
    setTimeout(() => {
      setIsAutoPlay(true);
    }, 3000);
  };

  // Auto-play functionality
  useEffect(() => {
    if (!isAutoPlay) return;

    const slider = sliderRef.current;
    if (!slider) return;

    const maxIndex = Math.max(0, techStack.length - visibleCards);

    const moveSlide = () => {
      let newIndex = currentIndex + direction;
      let newDirection = direction;

      if (newIndex >= maxIndex) {
        newDirection = -1;
        newIndex = maxIndex - 1;
      } else if (newIndex <= 0) {
        newDirection = 1;
        newIndex = 1;
      }

      setCurrentIndex(newIndex);
      setDirection(newDirection);

      slider.style.transform = `translateX(-${newIndex * itemWidth}px)`;
      slider.style.transition = "transform 0.6s ease";
    };

    const interval = setInterval(moveSlide, 5000);
    return () => clearInterval(interval);
  }, [currentIndex, direction, techStack.length, visibleCards, isAutoPlay]);

  return (
    <div ref={containerRef} className="overflow-hidden pointer-events-auto">
      <div className="w-full mt-10">
        <div className="relative overflow-hidden">
          <div
            ref={sliderRef}
            className="flex items-center"
            style={{ width: "max-content", transition: "transform 0.6s ease" }}
          >
            {techStack.map((tech, index) => (
              <div
                key={`${tech.name}-${index}`}
                className="rounded-2xl flex items-center justify-center group cursor-pointer overflow-hidden mr-4 dark:invert "
                style={{ width: `${itemWidth}px`, height: '112px' }}
              >
                <img
                  src={tech.logoUrl}
                  alt={tech.name}
                  className="h-12 md:h-14 object-contain"
                />
              </div>
            ))}
          </div>
        </div>

        {/* Navigation Dots */}
        {totalSlides > 1 && (
          <div className="flex justify-center my-6 space-x-3">
            {Array.from({ length: totalSlides }, (_, index) => (
              <button
                key={index}
                onClick={() => moveToSlide(index)}
                className={`
                  w-3 h-3 rounded-full transition-all duration-300 cursor-pointer
                  ${
                    currentIndex === index
                      ? "bg-[#EE005B] scale-125 shadow-lg"
                      : "bg-gray-400 hover:bg-gray-300 hover:scale-110"
                  }
                `}
                aria-label={`Go to slide ${index + 1}`}
                onMouseEnter={() => setIsAutoPlay(false)}
                onMouseLeave={() => {
                  setTimeout(() => setIsAutoPlay(true), 1000);
                }}
              />
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

const WebSec2 = () => {
  return (
    <div className="py-10 xl:px-35 px-10 relative z-10">
      <h3 className="text-center text-xl dark:text-zinc-400 text-zinc-500">
        Technologies we apply.
      </h3>

      <TechStackSlider />
    </div>
  );
};

export default WebSec2;
